import React from 'react';
import './Affiliates.css';

const Affiliates = () => {
  return (
    <div className="affiliates-page">
      <div className="container">
        <h1>Affiliates</h1>
        <p>Join our affiliate program and earn commissions.</p>
        {/* Affiliates information will go here */}
        <div className="affiliates-content">
        </div>
      </div>
    </div>
  );
};

export default Affiliates;